import { connect } from 'react-redux'
import {
  compose, lifecycle, withState, withHandlers,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { updateSiteConfiguration, updateSiteConfigs } from 'actions/Site'
import { fetchAboutPakde } from 'actions/AboutPakde'
import AboutPakdeView from 'components/pages/webManagement/aboutPakde/List'

export function mapStateToProps(state) {
  const { currentUser } = state.root.auth

  return {
    currentUser,
  }
}

const mapDispatchToProps = dispatch => ({
  updateSiteConfiguration: bindActionCreators(updateSiteConfiguration, dispatch),
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchAboutPakde: bindActionCreators(fetchAboutPakde, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('aboutPakdeList', 'setAboutPakdeList', {
    data: [],
    meta: {},
    isFetching: true,
  }),
  withHandlers({
    getAboutPakde: props => (params) => {
      props.fetchAboutPakde(params)
        .then((result) => {
          props.setAboutPakdeList({
            data: [result.data],
            meta: result.meta,
            isFetching: false,
          })
        })
        .catch(() => {
          props.setAboutPakdeList({
            data: [],
            meta: {},
            isFetching: false,
          })
        })
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfiguration('breadList', ['Home', 'Web Management', 'About Pak-D'])
      this.props.updateSiteConfigs({
        titlePage: 'About Pak-D',
        activePage: 'web-management/about-pak-d',
        activeSubPage: 'web-management',
      })
      this.props.getAboutPakde()
    },
  }),
)(AboutPakdeView)
